import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import React from 'react';
import { useNavigate } from 'react-router';
import { useAlertUiTranslation } from '../../../../hooks';
import { useAlertsUrl } from '../../../../hooks/useAlertsUrl';
import { showNotificationDialog } from '../AlertDialog';
export function useAlertSlideout(params) {
    const [open, setOpen] = React.useState(false);
    const [reloadFlag, setReloadFlag] = React.useState({});
    const { t } = useAlertUiTranslation();
    const alertsSentUrlFromConfig = useAlertsUrl('sent');
    const navigationContext = React.useContext(NavigationContext);
    const navigate = useNavigate();
    const handleOpenSlideout = () => {
        setOpen(true);
        setReloadFlag({});
    };
    const handleCloseSlideout = () => {
        setOpen(false);
        if (params === null || params === void 0 ? void 0 : params.onSlideoutClose) {
            params.onSlideoutClose();
        }
    };
    const onAlertCreate = (alertId) => {
        showNotificationDialog({
            alertId: alertId,
            mode: 'notification',
            dialogStep: alertId ? 'review' : 'templates',
            reviewFormHeader: t('pages.newFromTemplate.reviewAndSend'),
            wizardHeader: t('pages.newFromTemplate.createNotification'),
            onSubmitSuccess: (_data, onClose) => {
                showAlertSnackbar({
                    message: t('pages.edit.snackbar.notification.sent'),
                    type: 'success',
                    autoHideDuration: 1000,
                });
                onClose();
                navigationContext.navigate(() => { var _a; return navigate((_a = params === null || params === void 0 ? void 0 : params.alertsSentUrl) !== null && _a !== void 0 ? _a : alertsSentUrlFromConfig); });
            },
        });
    };
    function handleSelect(alertId) {
        setOpen(false);
        onAlertCreate(alertId);
    }
    function handleCreateAlert() {
        setOpen(false);
        onAlertCreate();
    }
    return {
        open,
        reloadFlag,
        handleOpenSlideout,
        handleCloseSlideout,
        handleSelect,
        handleCreateAlert,
    };
}
